import React from 'react'
import Dialog from '@mui/material/Dialog'
import { makeStyles } from '@mui/styles'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'

/**
 * Modal to provide a custom container for embedding an iFrame content
 *
 * @param props
 * @returns {*}
 * @constructor
 */

const useStyles = makeStyles((props) => ({
  paper: {
    margin: 0,
    padding: 0,
  },
  content: (props) => ({
    padding: 0,
    overflowX: 'hidden',
    '&:first-child': (props) => ({
      padding: 0,
    }),
  }),
  actions: {
    padding: '20px 32px',
  },
  ...props.classes,
}))

const IFrameContent = (props) => {
  const {
    actions,
    children,
    dataQsId,
    ...otherProps
  } = props

  const classes = useStyles(props)
  const hasActions = actions && actions.length
  const actionEl = hasActions
    ? <DialogActions classes={{ root: classes.actions }}>{actions}</DialogActions>
    : null

  return (
    <Dialog dataQsId={dataQsId} {...otherProps}
      classes={{ paper: classes.paper }}>
      {hasActions && <DialogContent classes={{ root: classes.content }}>
        {children}
      </DialogContent>}
      {!hasActions && children}
      {actionEl}
    </Dialog>
  )
}

export default IFrameContent
